import { createAction } from '../../utils/action';
import ActionTypes from '../actionTypes';
import { ActionsUnion } from '../types';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import { Notification, NotificationType } from './types';

export const Actions = {
  getNotifications: () => createAction(ActionTypes.GET_NOTIFICATIONS),
  getNotificationsSuccess: (notifications: Notification[]) => createAction(ActionTypes.GET_NOTIFICATIONS_SUCCESS, notifications),
  getNotificationsError: (error: RestErrorResponse) => createAction(ActionTypes.GET_NOTIFICATIONS_ERROR, error),

  getNotificationTypes: () => createAction(ActionTypes.GET_NOTIFICATION_TYPES),
  getNotificationTypesSuccess: (notifications: NotificationType[]) => createAction(ActionTypes.GET_NOTIFICATION_TYPES_SUCCESS, notifications),
  getNotificationTypesError: (error: RestErrorResponse) => createAction(ActionTypes.GET_NOTIFICATION_TYPES_ERROR, error),

  saveNotificationType: () => createAction(ActionTypes.SAVE_NOTIFICATION_TYPE),
  saveNotificationTypeSuccess: () => createAction(ActionTypes.SAVE_NOTIFICATION_TYPE_SUCCESS),
  saveNotificationTypeError: (error: RestErrorResponse) => createAction(ActionTypes.SAVE_NOTIFICATION_TYPE_ERROR, error)
};

export type NotificationsActions = ActionsUnion<typeof Actions>;
